import request from "@/utils/request";

export function getCaptchaImg() {
  return request({
    url: "/api/login/captcha",
    method: "post"
  });
}

export function sysSetParams(data) {
  return request({
    url: "/api/login/sysSetParams",
    method: "post",
    data
  });
}

export function liveParams(data) {
  return request({
    url: "/api/login/liveParams",
    method: "post",
    data
  });
}

export function checkToken(data) {
  return request({
    url: "/api/login/checkToken",
    method: "post",
    data
  });
}

export function login(data) {
  return request({
    url: "/api/login/login",
    method: "post",
    data
  });
}
export function myInfo(data) {
  return request({
    url: "/api/login/myInfo",
    method: "post",
    data
  });
}

export function logout(data) {
  return request({
    url: "/api/login/logout",
    method: "post",
    data
  });
}

export function updPwd(data) {
  return request({
    url: "/api/login/updPwd",
    method: "post",
    data
  });
}

export function addPerson(data) {
  return request({
    url: "/api/login/addPerson",
    method: "post",
    data
  });
}

export function getExamList(data) {
  return request({
    url: "/api/exam/getExamList",
    method: "post",
    data
  });
}

export function getExamById(data) {
  return request({
    url: "/api/exam/getExamById",
    method: "post",
    data
  });
}

export function getTestInfo(data) {
  return request({
    url: "/api/exam/getTestInfo",
    method: "post",
    data
  });
}

export function answerUpload(data) {
  return request({
    url: "/api/exam/answerUpload",
    method: "post",
    data
  });
}
export function lookTest(data) {
  return request({
    url: "/api/exam/lookTest",
    method: "post",
    data
  });
}

export function submitSignleExam(data) {
  return request({
    url: "/api/exam/submitSignleExam",
    method: "post",
    data
  });
}

export function submitTest(data) {
  return request({
    url: "/api/exam/submitTest",
    method: "post",
    data
  });
}

export function examFace(data) {
  return request({
    url: "/api/exam/submitPicExam",
    method: "post",
    data
  });
}

export function updateExamUserFirstPhone(data) {
  return request({
    url: "/api/exam/updateExamUserFirstPhone",
    method: "post",
    data
  });
}

export function lookAllScore(data) {
  return request({
    url: "/api/exam/lookAllScore",
    method: "post",
    data
  });
}

export function createH5FaceOrder(data) {
  return request({
    url: "/api/faceVerify/createH5FaceOrder",
    method: "post",
    data
  });
}

export function createQueryfaceRecord(data) {
  return request({
    url: "/api/faceVerify/createQueryfaceRecord",
    method: "post",
    data
  });
}

export function sysDescById(data) {
  return request({
    url: "/api/login/sysDescById",
    method: "post",
    data
  });
}

export function getServerTime() {
  return request({
    url: "/api/login/getServerTime",
    method: "post"
  });
}

export function sendStopPushStreamMsg(data) {
  return request({
    url: "/api/login/sendStopPushStreamMsg",
    method: "post",
    data
  });
}